import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActionSheetController, AlertController, IonList, IonSearchbar, ModalController, NavController, ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { Observable, Subscription, combineLatest, firstValueFrom, map } from 'rxjs';
import { ModaisIdEnum, ModaisService } from 'src/app/core/services/behavior/modais.service';
import { StorageService } from 'src/app/core/services/behavior/storage.service';
import { ConfigSistemaService } from 'src/app/core/services/behavior/config-sistema.service';
import { AuthenticationService } from 'src/app/core/services/http/authentication.service';
import { PedidoService } from 'src/app/core/services/http/pedido.service';
import { PessoaService } from 'src/app/core/services/http/pessoa.service';
import { ProdutoService } from 'src/app/core/services/http/produto.service';
import { TamanhoService } from 'src/app/core/services/http/tamanho.service';
import { MontarItemComponent, MontarItemDataClose } from 'src/app/shared/components/montar-item/montar-item.component';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { TipoAtendimentoEnum } from '../../enums/tipo-atendimento.enum';
import { MetodosModal } from '../../interfaces/metodos-modal.interface';
import { ModalResult } from '../../interfaces/modal-result.interface';
import { PedidoModel } from '../../models/pedido.model';
import { ProdutoFamiliaModel } from '../../models/produto-familia.model';
import { ProdutoBalancaModel, ProdutoModel } from '../../models/produto.model';
import { TamanhoResponseModel } from '../../models/tamanho.model';
import { UsuarioModel } from '../../models/usuario.model';
import { VendasDetalheModel } from '../../models/vendas-detalhe.model';
import { DialogStateUtil } from '../../utils/dialog-state.util';
import { HelpersUtil } from '../../utils/helpers.util';
import { PagarContaComponent } from '../pagar-conta/pagar-conta.component';
import { ProdutoQtdeVendaDialogComponent } from '../produto-qtde-venda-dialog/produto-qtde-venda.component';

@Component({
    selector: 'app-selecionar-produto',
    templateUrl: './selecionar-produto.component.html',
    styleUrls: ['./selecionar-produto.component.scss'],
})
export class SelecionarProdutoComponent implements ViewWillEnter, ViewWillLeave, MetodosModal {
    private readonly _alertPreencherNomeClienteId = 'alertPreencherNomeCliente';
    private readonly _btnConfirmarAlertPreencherNomeClienteId = 'btnConfirmaralertPreencherNomeCliente';
    // ModalProps
    private readonly isPrimeiraSincronizacao = true;

    public readonly pedido: PedidoModel;
    public readonly tipoAtendimento: TipoAtendimentoEnum;

    @ViewChild('list', { static: false, read: ElementRef }) private list: ElementRef;
    @ViewChild('listFamilia', { static: false }) private listFamilia: IonList;
    @ViewChild('searchbar', { static: false }) private searchbar: IonSearchbar;

    private _podeRemoverItemPedido = false;
    private arrFamiliasFull: ProdutoFamiliaModel[] = [];
    private arrLasanhas: ProdutoModel[] = [];
    private arrPizzas: ProdutoModel[] = [];
    private arrProdutosFull: ProdutoModel[] = [];
    private arrTamanhoLasanha: TamanhoResponseModel[] = [];
    private arrTamanhoPizza: TamanhoResponseModel[] = [];
    private confirmarFechamentoActionSheet: HTMLIonActionSheetElement = null;
    private configSistemaSubscription$: Subscription;
    private confirmarFechamentoIsOpen = false;
    private dialogMontarItemIsOpen = false;
    private dialogObservacoesProdutoIsOpen = false;
    private familiaAtual: ProdutoFamiliaModel;
    private modalRef: HTMLIonModalElement = null;
    private searchbarIsFocused = false;
    private subscription$: Subscription;

    public activeTab: 'produtosEmLancamento' | 'produtosJaLancados' = 'produtosEmLancamento';
    public arrFamilias: ProdutoFamiliaModel[] = [];
    public arrProdutos: ProdutoModel[] = [];
    public arrProdutosFiltrados: ProdutoModel[] = [];
    public centerIndex = 0;
    public detSelecionado: VendasDetalheModel = null;
    public indexFamiliaSelecionada = 0;
    public indexProdutoSelecionado = -1;
    public isAutoAtendimento = false;
    mesaOcupada$: Observable<boolean>;
    public produtosJaLancados: VendasDetalheModel[] = [];
    public scrollingToItem = false;
    public tabelaMinimizada = true;
    public percentualAlturaMenuProdutos = 25;

    constructor(
        private _alertCtrl: AlertController,
        private actionSheetCtrl: ActionSheetController,
        private modalCtrl: ModalController,
        private navCtrl: NavController,

        private _pessoaService: PessoaService,
        private authService: AuthenticationService,
        private _modaisService: ModaisService,
        private produtoService: ProdutoService,
        private storageService: StorageService,
        private tamanhoService: TamanhoService,
        private _pedidoService: PedidoService,
        private _configSistemaService: ConfigSistemaService
    ) { }

    public get tipoAtendimentoDeliveryOuMesa() {
        return this.tipoAtendimento === TipoAtendimentoEnum.DELIVERY ||
            this.tipoAtendimento === TipoAtendimentoEnum.MESA;
    }

    public get totalProdutosEmLancamento() {
        return HelpersUtil.sumArray(this.pedido.dets);
    }

    private async _obterModalSangriaSuprimentoAsync(produtoBalanca: ProdutoBalancaModel) {
        return await this.modalCtrl.create({
            component: ProdutoQtdeVendaDialogComponent,
            cssClass: 'sangria-suprimento-dialog',
            componentProps: {
                produto: produtoBalanca
            }
        });
    }

    public async abrirModalSangriaAsyncOnClick(produto: ProdutoBalancaModel) {
        const modal = await this._obterModalSangriaSuprimentoAsync(produto);

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult: ModalResult<ProdutoBalancaModel> = await modal.onWillDismiss();


        return (modalResult.role === ModalRoleEnum.CONFIRM) ? modalResult.data.qtde : 0;
    }

    public async adicionarProduto(produto: ProdutoModel) {
        let det = this.pedido.dets.find(l => l.codigoProduto === produto.codigo);

        let qtde = 1;
        let produtoBalanca: ProdutoBalancaModel = null;
        if (produto.utilizaBalanca) {
            produtoBalanca = new ProdutoBalancaModel(produto);
            produtoBalanca.valorUnit = produto.valorVenda;
            this.confirmarFechamentoIsOpen = true;
            await this.abrirModalSangriaAsyncOnClick(produtoBalanca);
            if (produtoBalanca.qtde == 0.000)
                return;

            produtoBalanca.setQtdePorValorTotal();
            qtde = produtoBalanca.qtde;

            this.confirmarFechamentoIsOpen = false;
        }

        if (det && !produto.utilizaBalanca) {
            det.qtd++;
        } else {
            det = new VendasDetalheModel({
                codigoProduto: produto.codigo,
                produto: produto,
                qtd: qtde,
                unMedCom: produto.unmed,
                venda: produto.valorVenda,
                codigoFamilia: produto.familia.codigo
            });

            this.pedido.dets.unshift(det);
        }

        //isso foi utilizado devido a dizima periodica, pra não ficar com 0.01 a mais do que o usuário digitou
        det.totalItem = produto.utilizaBalanca ? produtoBalanca.valorTotal : det.obterTotalItem();

        produto.qtd = det.qtd;

        this.modalRef.backdropDismiss = false;

        this.searchbar.value = '';
        this.searchbar.setFocus();

        this.filtrarProdutos('');

        this.scrollToItem(0);
    }

    public async cancel() {
        if (this.confirmarFechamentoIsOpen) {
            await this.confirmarFechamentoActionSheet.dismiss();
            return;
        }

        if (this.getQtdItens() && !this.modalRef.backdropDismiss) {
            const confirmacao = await this.confirmarFechamento();

            if (confirmacao) {
                await this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
                DialogStateUtil.dialogIsClosed();
            }
        } else {
            await this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
            DialogStateUtil.dialogIsClosed();
        }
    }

    public async confirm() {
        this.pedido.codigoEmpresa = 1;

        if (this.pedido.dets.length == 0) {
            this.cancel();
        }

        if (this.tipoAtendimento === TipoAtendimentoEnum.BALCAO && !this.pedido.cliente.nome && !(await this._alertPreencherNomeClienteEstaAberto())) {
            const resultadoAlert = await this._alertPreencherNomeClienteAsync();
            const nomeCliente = resultadoAlert.data.values[0];

            if (!nomeCliente) {
                return await this.showErrorMessage('Informe o nome do cliente.');
            }

            this.pedido.cliente.nome = nomeCliente;
        }

        const dataClose = new SelecionarProdutoDataClose(this.pedido);

        await this.modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);

        DialogStateUtil.dialogIsClosed();
    }

    public definirAbaAtiva(abaAtiva: 'produtosEmLancamento' | 'produtosJaLancados') {
        this.activeTab = abaAtiva;

        if (this.activeTab === 'produtosJaLancados') {
            this.carregarProdutosJaLancados();
        }
    }

    public disabledConfirm() {
        return false; //!this.pedido.dets.length;
    }

    public async excluirDet(codigo: number, index: number) {
        if (!this._podeRemoverItemPedido) {
            await this.showErrorMessage('Você não tem permissão para cancelar o pedido. Por favor, selecione um usuário que tenha autorização.');

            const confirmarUsuarioDialogDataClose = await this._modaisService.modalConfirmarUsuarioDialogAsync();

            if (confirmarUsuarioDialogDataClose.role === ModalRoleEnum.CANCEL)
                return;

            if (!confirmarUsuarioDialogDataClose.data.usuario.bloqueiaCancelaProd)
                return await this.showErrorMessage('O usuário selecionado também não possui a permissão desejada.');
        }

        this._pedidoService.cancelarVendasDet(codigo).subscribe(res => {
            if (res.success) {
                this.produtosJaLancados.splice(index, 1);
            }
        })
    }

    // if (!this.podeCancelarPedido) {
    //   await this.showErrorMessage('Você não tem permissão para cancelar o pedido. Por favor, selecione um usuário que tenha autorização.');

    //   const confirmarUsuarioDialogDataClose = await this._modaisService.modalConfirmarUsuarioDialogAsync();

    //   if (confirmarUsuarioDialogDataClose.role === ModalRoleEnum.CANCEL)
    //     return;

    //   if (!confirmarUsuarioDialogDataClose.data.usuario.pdV_CancelarPedido)
    //     return await this.showErrorMessage('O usuário selecionado também não possui a permissão desejada.');
    // }

    // this.pedidoService.cancelarPedido(numeroComanda).subscribe(res => {
    //   if (res) {
    //     this.reload();
    //   }
    // })

    public filtrarProdutos(value: string) {
        const familiaAtiva = this.obterFamiliaAtiva();

        if (familiaAtiva)
            familiaAtiva.classList.remove('fam_active');

        if (!value) {
            this.familiaAtual = null;
            this.arrProdutosFiltrados = [];

            this.indexFamiliaSelecionada = 0;
            this.indexProdutoSelecionado = -1;

            this._prepararFamilias();
            return;
        }

        value = HelpersUtil.prepareValue(value);

        this.arrFamilias = [];
        this.arrProdutosFiltrados = this.arrProdutos.filter(l => HelpersUtil.prepareValue(l.nome).includes(value));

        if (this.arrProdutosFiltrados.length === 0) {
            this.indexProdutoSelecionado = -1;
        } else if (this.arrProdutosFiltrados.length === 1) {
            this.indexProdutoSelecionado = 0;
        }
    }

    public async ionViewWillEnter(): Promise<void> {
        this.isAutoAtendimento = this.authService.isAutoAtendimento;

        await this.load();

        if (this.isAutoAtendimento) {
            HelpersUtil.executeAfterDelay(() => this.centerAndHighlightItem(), 1000);
        }

        if (!this.isAutoAtendimento) {
            this.tabelaMinimizada = false;
        }

        HelpersUtil.executeAfterDelay(() => {
            this.searchbar.setFocus();
            this.searchbarIsFocused = true;
        });

        this.modalRef = await this.modalCtrl.getTop();

        this.searchbar.ionBlur.subscribe(() => this.searchbarIsFocused = false);

        const usuarioLogado = await this.storageService.get('user') as UsuarioModel;

        this._podeRemoverItemPedido = usuarioLogado.bloqueiaCancelaProd === true;

        if (!this.pedido.numeroComanda) {
            return;
        }

        this.mesaOcupada$ = this._pedidoService.verificarMesaOcupada(this.pedido.numeroComanda).pipe(map(l => l.success ? l.data : false));
    }

    public ionViewWillLeave(): void {
        if (this.subscription$)
            this.subscription$.unsubscribe();

        if (this.configSistemaSubscription$)
            this.configSistemaSubscription$.unsubscribe();
    }

    public get alturaMenuProdutosPercentual(): number {
        return Math.min(100, Math.max(5, this.percentualAlturaMenuProdutos || 25));
    }

    public async modalMontarLasanha() {
        const modal = await this.modalCtrl.create({
            component: MontarItemComponent,
            componentProps: {
                lblTipo: 'LASANHA',
                arrItensReadonly: this.arrLasanhas,
                numeroComanda: this.pedido.numeroComanda,
                arrTamanhos: this.arrTamanhoLasanha
            },
            cssClass: 'full-screen-dialog',
            id: "modalMontarItem"
        });

        await modal.present();

        this.dialogMontarItemIsOpen = true;
        this.familiaAtual = null;

        const modalResult: ModalResult<MontarItemDataClose> = await modal.onWillDismiss();

        HelpersUtil.executeAfterDelay(() => {
            this.dialogMontarItemIsOpen = false;
            this._definirFocoNoSearchbar();
        }, 600);

        if (modalResult.role === ModalRoleEnum.CONFIRM)
            this.pedido.dets.unshift(modalResult.data.det);
    }

    public async modalMontarPizza() {
        const modal = await this.modalCtrl.create({
            component: MontarItemComponent,
            componentProps: {
                lblTipo: 'PIZZA',
                arrItensReadonly: this.arrPizzas,
                numeroComanda: this.pedido.numeroComanda,
                arrTamanhos: this.arrTamanhoPizza
            },
            cssClass: 'full-screen-dialog',
            id: "modalMontarItem"
        });

        await modal.present();

        this.dialogMontarItemIsOpen = true;
        this.familiaAtual = null;

        const modalResult: ModalResult<MontarItemDataClose> = await modal.onWillDismiss();

        HelpersUtil.executeAfterDelay(() => {
            this.dialogMontarItemIsOpen = false;
            this._definirFocoNoSearchbar();
        }, 600);

        if (modalResult.role === ModalRoleEnum.CONFIRM)
            this.pedido.dets.unshift(modalResult.data.det);
    }

    public async modalObservacoesProduto(det: VendasDetalheModel) {
        const modalResult = await this._modaisService.modalObservacoesProdutoAsync(det);

        if (modalResult.role === ModalRoleEnum.CONFIRM)
            det.obs = modalResult.data.obs;
    }

    public async modalVerConta(): Promise<void> {
        const modal = await this.modalCtrl.create({
            component: PagarContaComponent,
            componentProps: {
                pedido: this.pedido
            },
            cssClass: 'full-screen-dialog'
        });

        await modal.present();
    }

    public removerProduto(det: VendasDetalheModel, index: number) {
        det.qtd--;

        if (det.qtd < 1)
            this.pedido.dets.splice(index, 1);
        else
            det.totalItem = det.obterTotalItem();

        det.produto.qtd = det.qtd;

        if (!this.getQtdItens()) {
            this.modalRef.backdropDismiss = true;
        }
    }

    public async selecionarClienteAsyncOnClick() {
        await this._selecionarClienteAsync();
    }

    public selecionarDet(det: VendasDetalheModel) {
        this.indexProdutoSelecionado = -1;

        if (det === this.detSelecionado)
            this.detSelecionado = null;
        else
            this.detSelecionado = det;
    }

    public selecionarFamilia(element: HTMLElement, index: number) {
        if (!this.isAutoAtendimento)
            this.ativarElementoFamilia(element);

        this.indexFamiliaSelecionada = index;
        this.indexProdutoSelecionado = -1;

        const familia = this.arrFamilias[index];

        this.familiaAtual = familia;

        familia.nome = HelpersUtil.prepareValue(familia.nome);

        switch (familia.nome) {
            case 'LASANHA':
                this.arrProdutosFiltrados = [];
                this.indexProdutoSelecionado = -1;

                this.arrLasanhas = this.arrProdutosFull.filter(p => HelpersUtil.prepareValue(p.familia.nome) === 'LASANHA');
                this.arrLasanhas = HelpersUtil.sortList(this.arrLasanhas, 'nome', true);
                this.modalMontarLasanha();
                break;
            case 'PIZZA':
                this.arrProdutosFiltrados = [];
                this.indexProdutoSelecionado = -1;

                this.arrPizzas = this.arrProdutosFull.filter(p => HelpersUtil.prepareValue(p.familia.nome) === 'PIZZA');
                this.arrPizzas = HelpersUtil.sortList(this.arrPizzas, 'nome', true);
                this.modalMontarPizza();
                break;
            default:
                this.arrProdutosFiltrados = this.arrProdutos.filter(p => HelpersUtil.prepareValue(p.familia.nome) === familia.nome);
                this.arrProdutosFiltrados = HelpersUtil.sortList(this.arrProdutosFiltrados, 'nome', true);
                break;
        }

        this.scrollToItem(index);
    }

    public selecionarProduto(element: Element, produto: ProdutoModel) {
        const index = this.arrProdutosFiltrados.indexOf(produto);

        this.indexProdutoSelecionado = index;

        const produtoAtivo = this.obterProdutoAtivo();

        if (produtoAtivo)
            produtoAtivo.classList.remove('prod_active');

        element.classList.add('prod_active');

        this.adicionarProduto(produto);
    }

    public toggleTabela() {
        this.tabelaMinimizada = !this.tabelaMinimizada;
    }

    @HostListener('document:keydown', ['$event'])
    public async handleKeyboardEvent(event: KeyboardEvent): Promise<void> {
        const idModal = (await this.modalCtrl.getTop()).id;

        switch (idModal) {
            case ModaisIdEnum.MONTAR_ITEM:
            case 'modalSelecionarCliente':
            case ModaisIdEnum.SELECIONAR_ENDERECO:
            case ModaisIdEnum.OBSERVACOES_PRODUTO:
            case ModaisIdEnum.CONFIRMAR_USUARIO:
                return;
        }

        const alertPreencherNomeClienteEstaAberto = await this._alertPreencherNomeClienteEstaAberto();

        switch (event.key) {
            case KeyboardKeysEnum.Escape:
                if (alertPreencherNomeClienteEstaAberto) return;

                await this.handleEscapeKey();
                break;
            case KeyboardKeysEnum.ArrowUp:
                event.preventDefault();
                event.stopPropagation();

                if (alertPreencherNomeClienteEstaAberto) return;

                this.handleArrowUpKey();
                break;
            case KeyboardKeysEnum.ArrowDown:
                event.preventDefault();
                event.stopPropagation();

                if (alertPreencherNomeClienteEstaAberto) return;

                this.handleArrowDownKey();
                break;
            case KeyboardKeysEnum.Enter:
                if (this.confirmarFechamentoIsOpen || alertPreencherNomeClienteEstaAberto) return;

                this.handleEnterKey();
                break;
            case KeyboardKeysEnum.F1:
                event.preventDefault();
                event.stopPropagation();

                break;
            case KeyboardKeysEnum.F5:
                if (this.confirmarFechamentoIsOpen) return;

                await this.handleF5Key();
                break;
            case KeyboardKeysEnum.F7:
                event.preventDefault();
                event.stopPropagation();

                if (this.confirmarFechamentoIsOpen) return;

                await this._lidarComTeclaF7Async();
                break;
            case KeyboardKeysEnum.F8:
                if (this.confirmarFechamentoIsOpen) return;

                this.handleF8Key();
                break;
            case KeyboardKeysEnum.Delete:
                if (this.confirmarFechamentoIsOpen) return;

                this.handleDeleteKey();
                break;
            case KeyboardKeysEnum.ArrowLeft:
                if (this.confirmarFechamentoIsOpen) return;

                if (this.arrFamilias.length > 0) {
                    this.handleArrowLeftKey();
                }

                break;
            case KeyboardKeysEnum.Tab:
                event.preventDefault();
                event.stopPropagation();

                break;
            case KeyboardKeysEnum.Insert:
                this.modalObservacoesProduto(this.pedido.dets[0]);
                event.preventDefault();
                event.stopPropagation();

                break;
            case KeyboardKeysEnum.F9:
                this.adicionarProduto(this.pedido.dets[0].produto);
                event.preventDefault();
                event.stopPropagation();

                break;
        }
    }

    private async _alertPreencherNomeClienteAsync() {
        const idNomeClienteInput = 'nomeClienteInput';

        const alert = await this._alertCtrl.create({
            header: 'Nome do Cliente',
            buttons: [
                {
                    text: 'Cancelar',
                    role: ModalRoleEnum.CANCEL
                },
                {
                    text: 'Confirmar',
                    role: ModalRoleEnum.CONFIRM,
                    id: this._btnConfirmarAlertPreencherNomeClienteId
                }
            ],
            inputs: [
                {
                    placeholder: 'Ex: João',
                    type: 'text',
                    id: idNomeClienteInput
                }
            ],
            id: this._alertPreencherNomeClienteId,
        });

        await alert.present();

        const input = document.getElementById(idNomeClienteInput);

        input.focus();

        input?.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                const btnConfirmar = document.getElementById(
                    this._btnConfirmarAlertPreencherNomeClienteId
                ) as HTMLButtonElement;

                btnConfirmar?.click();
            }
        });

        return await alert.onDidDismiss();
    }

    private async _alertPreencherNomeClienteEstaAberto() {
        return (await this._alertCtrl.getTop())?.id == this._alertPreencherNomeClienteId;
    }

    private _definirFocoNoSearchbar() {
        this.searchbar.setFocus();
        this.searchbarIsFocused = true;
    }

    private async _lidarComErroAoObterEnderecosCliente() {
        const existeMensagemErroAberto = this._alertCtrl.getTop();

        if (existeMensagemErroAberto)
            await this._alertCtrl.dismiss();

        await this.cancel();
    }

    private async _lidarComTeclaF7Async() {
        await this._selecionarClienteAsync();
    }

    private async _obterEnderecosClienteAsync(codigoCliente: number) {
        const obs$ = this._pessoaService.getAllEnderecos(codigoCliente).pipe(
            map(response => {
                if (response.success) {
                    return response.data;
                } else {
                    throw new Error('Erro ao obter endereços');
                }
            }),
        );

        return await firstValueFrom(obs$);
    }

    private _prepararFamilias() {
        this.arrFamilias = Array.from(this.arrFamiliasFull)
            .filter(f => HelpersUtil.prepareValue(f.nome) !== 'COMPLEMENTO DE PEDIDO' && HelpersUtil.prepareValue(f.nome) !== 'SERVICOS')
            .filter(f => this.arrProdutosFull.some(p => p.familia.codigo === f.codigo));

        const familiaPizza = this.arrFamilias.find(l => HelpersUtil.prepareValue(l.nome) === 'PIZZA')
        const familiaLasanha = this.arrFamilias.find(l => HelpersUtil.prepareValue(l.nome) === 'LASANHA')

        this.arrFamilias = HelpersUtil.sortList(this.arrFamilias, 'nome', true);
        this.arrFamilias = HelpersUtil.moveObjectToPosition(this.arrFamilias, familiaPizza, 0);
        this.arrFamilias = HelpersUtil.moveObjectToPosition(this.arrFamilias, familiaLasanha, 1);
    }

    private async _selecionarClienteAsync() {
        const modalSelecionarClienteResult = await this._modaisService.modalSelecionarClienteAsync();

        if (modalSelecionarClienteResult.role === ModalRoleEnum.CONFIRM) {
            this.pedido.cliente = modalSelecionarClienteResult.data.cliente;

            try {
                const enderecosCliente = await this._obterEnderecosClienteAsync(this.pedido.cliente.codigo);

                if (enderecosCliente.length > 1 && this.tipoAtendimento === TipoAtendimentoEnum.DELIVERY) {
                    const modalResultSelecionarEndereco = await this._modaisService.modalSelecionarEnderecoAsync(enderecosCliente);

                    if (modalResultSelecionarEndereco.role === ModalRoleEnum.CONFIRM) {
                        this.pedido.codigoEndereco = modalResultSelecionarEndereco.data.endereco.codigo;
                    } else if (modalResultSelecionarEndereco.role === ModalRoleEnum.CANCEL) {
                        return await this.cancel();
                    }
                }
            } catch (error) {
                HelpersUtil.executeAfterDelay(async () => await this._lidarComErroAoObterEnderecosCliente(), 3000);
            }
        }
    }

    private ativarElementoFamilia(element: HTMLElement) {
        const familiaAtiva = this.obterFamiliaAtiva();

        if (familiaAtiva)
            familiaAtiva.classList.remove('fam_active');

        element.classList.add('fam_active');
    }

    private carregarProdutosJaLancados() {
        const sub$ = this._pedidoService.obterListaDets(this.pedido.numeroComanda)
            .pipe(
                map(l => l.success ? l.data : []))
            .subscribe(res => this.produtosJaLancados = res);
    }

    private centerAndHighlightItem() {
        const middleIndex = Math.floor(this.arrFamilias.length / 2);

        this.centerIndex = middleIndex;

        const ionItem = this.listFamilia['el'].children[middleIndex] as HTMLElement;

        this.scrollToItem(middleIndex);

        if (!this.isAutoAtendimento)
            this.ativarElementoFamilia(ionItem);
    }

    private async confirmarFechamento(): Promise<boolean> {
        this.confirmarFechamentoActionSheet = await this.actionSheetCtrl.create({
            header: 'Deseja realmente cancelar?',
            buttons: [
                {
                    text: 'Sim',
                    role: ModalRoleEnum.CONFIRM,
                    id: 'btnSimActionSheet'
                },
                {
                    text: 'Não',
                    role: ModalRoleEnum.CANCEL,
                    id: 'btnNaoActionSheet'
                },
            ],
            backdropDismiss: false
        });

        this.confirmarFechamentoActionSheet.present();

        this.confirmarFechamentoIsOpen = true;

        const btnSim = document.querySelector('#btnSimActionSheet') as HTMLButtonElement;

        HelpersUtil.executeAfterDelay(() => btnSim.focus(), 200);

        const { role } = await this.confirmarFechamentoActionSheet.onWillDismiss();

        HelpersUtil.executeAfterDelay(() => this.confirmarFechamentoIsOpen = false);

        return role === ModalRoleEnum.CONFIRM;
    }

    private getQtdItens() {
        return HelpersUtil.sumArray(this.pedido.dets, 'qtd');
    }

    private handleArrowDownKey() {
        if (this.confirmarFechamentoIsOpen) {
            const btnNao = document.querySelector('#btnNaoActionSheet') as HTMLButtonElement;

            btnNao.focus();
            return;
        }

        if (!this.familiaAtual && this.arrProdutosFiltrados.length === 0) {
            this.indexFamiliaSelecionada = HelpersUtil.selectNextItem(this.indexFamiliaSelecionada, this.arrFamilias.length);

            const element = document.querySelector(`[data-fam-index="${this.indexFamiliaSelecionada}"]`);

            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            this.navigate(1);
            this.setFocus();
        }
    }

    private handleArrowLeftKey() {
        this.indexProdutoSelecionado = -1;
        this.arrProdutosFiltrados = [];
        this.familiaAtual = null;
    }

    private handleArrowUpKey() {
        if (this.confirmarFechamentoIsOpen) {
            const btnSim = document.querySelector('#btnSimActionSheet') as HTMLButtonElement;

            btnSim.focus();
            return;
        }

        if (!this.familiaAtual && this.arrProdutosFiltrados.length === 0) {
            this.indexFamiliaSelecionada = HelpersUtil.selectPreviousItem(this.indexFamiliaSelecionada);

            const element = document.querySelector(`[data-fam-index="${this.indexFamiliaSelecionada}"]`);

            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            this.navigate(-1);
            this.setFocus();
        }
    }

    private handleDeleteKey() {
        if (this.detSelecionado) {
            this.detSelecionado.produto.qtd = null;

            const indexDetSelecionado = this.pedido.dets.indexOf(this.detSelecionado);

            this.pedido.dets.splice(indexDetSelecionado, 1);

            this.detSelecionado = null;

            return;
        }

        const produtoParaRemover = this.arrProdutosFiltrados[this.indexProdutoSelecionado];

        if (!produtoParaRemover) return;

        const det = this.pedido.dets.find(l => l.codigoProduto === produtoParaRemover.codigo);

        if (!det) return;

        const index = this.pedido.dets.indexOf(det);

        this.removerProduto(det, index);
    }

    private handleEnterKey() {
        if (!this.familiaAtual) {
            const element: HTMLElement = document.querySelector(`[data-fam-index="${this.indexFamiliaSelecionada}"]`);

            if (element) {
                const familia = this.arrFamilias[this.indexFamiliaSelecionada];
                const index = this.arrFamilias.indexOf(familia);

                this.selecionarFamilia(element, index);
                return;
            }
        }

        const produtoParaAdicionar = this.arrProdutosFiltrados[this.indexProdutoSelecionado];

        if (produtoParaAdicionar) {
            this.adicionarProduto(produtoParaAdicionar);
        }
    }

    private async handleEscapeKey() {
        if (this.confirmarFechamentoIsOpen) {
            (await this.actionSheetCtrl.getTop()).dismiss();
            return;
        };

        await this.cancel();
    }

    private async handleF5Key() {
        const alertPreencherNomeClienteEstaAberto = await this._alertPreencherNomeClienteEstaAberto();

        if (alertPreencherNomeClienteEstaAberto) {
            const btnConfirmar = document.getElementById(this._btnConfirmarAlertPreencherNomeClienteId);

            return btnConfirmar.click();
        }

        if (!this.disabledConfirm()) {
            HelpersUtil.executeAfterDelay(async () => await this.confirm());
        }
    }

    private handleF8Key() {
        this._definirFocoNoSearchbar();
    }

    private async load(): Promise<void> {
        this._carregarConfiguracaoAlturaMenuProdutos();

        await this.loadArrays();

        const existemDadosFaltantes = this.arrFamiliasFull == null || this.arrFamiliasFull == null || this.arrTamanhoLasanha == null || this.arrTamanhoPizza == null;

        if (existemDadosFaltantes) {
            const produtosDelivery$ = this.produtoService.getProdutosDelivery();
            const produtosFamilia$ = this.isAutoAtendimento ? this.produtoService.getFamiliasAutoAtendimento() : this.produtoService.getProdutosFamilia();
            const tamanhosLasanha$ = this.tamanhoService.getTamanhosLasanha();
            const tamanhosPizza$ = this.tamanhoService.getTamanhosPizza();

            const combinedObservable$ = combineLatest([
                produtosDelivery$,
                produtosFamilia$,
                tamanhosLasanha$,
                tamanhosPizza$
            ]).pipe(
                map(([produtosDeliveryRes, produtosFamiliaRes, tamanhosLasanhaRes, tamanhosPizzaRes]) => ({
                    produtosDelivery: produtosDeliveryRes.success || produtosDeliveryRes.data ? produtosDeliveryRes.data : [],
                    produtosFamilia: produtosFamiliaRes.success || produtosFamiliaRes.data ? produtosFamiliaRes.data : [],
                    tamanhosLasanha: tamanhosLasanhaRes.success || tamanhosLasanhaRes.data ? tamanhosLasanhaRes.data : [],
                    tamanhosPizza: tamanhosPizzaRes.success || tamanhosPizzaRes.data ? tamanhosPizzaRes.data : [],
                }))
            );

            this.subscription$ = combinedObservable$.subscribe({
                next: async res => {
                    const produtosDelivery = res.produtosDelivery;
                    const produtosFamilia = res.produtosFamilia;
                    const tamanhosLasanha = res.tamanhosLasanha;
                    const tamanhosPizza = res.tamanhosPizza;

                    await Promise.all([
                        this.storageService.set('produtos', produtosDelivery),
                        this.storageService.set('familiaProdutos', produtosFamilia),
                        this.storageService.set('tamanhosLasanha', tamanhosLasanha),
                        this.storageService.set('tamanhosPizza', tamanhosPizza),
                    ]);

                    await this.loadArrays();

                    this.prepararArrays();
                }
            });
        } else {
            this.prepararArrays();
        }
    }

    private async loadArrays(): Promise<void> {
        const [produtos, familias, tamanhoLasanhas, tamanhoPizzas] = await Promise.all([
            this.storageService.get('produtos'),
            this.storageService.get('familiaProdutos'),
            this.storageService.get('tamanhosLasanha'),
            this.storageService.get('tamanhosPizza')
        ]);

        this.arrProdutosFull = produtos;
        this.arrFamiliasFull = familias;
        this.arrTamanhoLasanha = tamanhoLasanhas;
        this.arrTamanhoPizza = tamanhoPizzas;
    }

    private _carregarConfiguracaoAlturaMenuProdutos(): void {
        let alturaMenuSaved = localStorage.getItem("percentualAltura");

        if (!alturaMenuSaved) {
            alturaMenuSaved = "25";
        }

        const alturaMenu = Number(alturaMenuSaved);

        this.percentualAlturaMenuProdutos = this._normalizarPercentualAlturaMenuProdutos(alturaMenu);

        // if (this.configSistemaSubscription$) {
        //     return;
        // }

        // this.configSistemaSubscription$ = this._configSistemaService.config$.subscribe(config => {
        //     this.percentualAlturaMenuProdutos = this._normalizarPercentualAlturaMenuProdutos(alturaMenu);
        // });
    }

    private _normalizarPercentualAlturaMenuProdutos(valor: number | null | undefined): number {
        const percentual = Number(valor);

        if (Number.isNaN(percentual)) {
            return 25;
        }

        return Math.min(100, Math.max(5, Math.round(percentual)));
    }

    private navigate(direction: number) {
        this.indexProdutoSelecionado = Math.min(Math.max(this.indexProdutoSelecionado + direction, 0), this.arrProdutosFiltrados.length - 1);

        if (this.list.nativeElement) {
            const tableElement = this.list.nativeElement;
            const rowElement = tableElement.querySelector(`[data-prod-index="${this.indexProdutoSelecionado}"]`);

            if (rowElement) {
                rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }

    private obterFamiliaAtiva(): Element | null {
        return document.querySelector('.fam_active');
    }

    private obterProdutoAtivo(): Element | null {
        return document.querySelector('.prod_active');
    }

    private prepararArrays(): void {
        this._prepararFamilias();

        this.arrProdutos = Array.from(this.arrProdutosFull)
            .filter(p => HelpersUtil.prepareValue(p.familia.nome) !== 'PIZZA')
            .filter(p => HelpersUtil.prepareValue(p.familia.nome) !== 'LASANHA')
            .filter(p => p.valorVenda > 0);
    }

    private scrollToItem(index: number): void {
        this.scrollingToItem = true;

        this.centerIndex = index;

        const itemElement = this.listFamilia['el'].children[index];

        if (itemElement) {
            itemElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        HelpersUtil.executeAfterDelay(() => this.scrollingToItem = false);
    }

    private setFocus(): void {
        const element = document.querySelector(`[data-prod-index="${this.indexProdutoSelecionado}"]`);

        const produtoAtivo = this.obterProdutoAtivo();

        if (produtoAtivo)
            produtoAtivo.classList.remove('prod_active');

        if (element)
            element.classList.add('prod_active');
    }

    private async showErrorMessage(msg: string) {
        const alert = await this._alertCtrl.create({
            header: 'ATENÇÃO',
            message: msg,
            buttons: ['OK']
        });

        await alert.present();

        await alert.onWillDismiss();
    }
}

export class SelecionarProdutoDataClose {
    constructor(
        public pedido: PedidoModel
    ) { }
}
